import React from 'react'
import { StyleProp, View } from 'react-native'
import { ImageStyle } from 'react-native-fast-image'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'
import { FlexView, LoadingFastImage } from '@src/components'
import { CarouselItemProps } from './Carousel.types'

export const CarouselItem = ({
  title,
  description,
  image,
  width,
  imageContainerStyle,
  imageStyle,
}: CarouselItemProps) => {
  const styles = useStyleSheet(themedStyles)
  return (
    <FlexView style={{ width }}>
      <View style={[styles.imageContainer, imageContainerStyle]}>
        <View style={[styles.image, imageStyle]}>
          <LoadingFastImage
            resizeMode="contain"
            source={image}
            style={styles.fastImage as StyleProp<ImageStyle>}
          />
        </View>
      </View>
      <View style={styles.textInfo}>
        <Text type="title-2" style={styles.textCenter}>
          {title}
        </Text>
        <Text type="regular" style={styles.textCenter}>
          {description}
        </Text>
      </View>
    </FlexView>
  )
}

const themedStyles = StyleService.create({
  imageContainer: {
    marginTop: 24,
    marginBottom: 24,
  },
  image: {
    width: '100%',
  },
  textInfo: {
    marginHorizontal: 24,
    gap: 16,
  },
  fastImage: {
    flex: 1,
    width: '100%',
    borderRadius: 20,
  },
  textCenter: {
    textAlign: 'center',
  },
})
